<ion-card
  routerLink="{{ itemData.category === 'fashion'  ? '/shopping/product/' + itemData.listing_id : '/shopping/product/' + itemData.id }}"
  routerDirection="forward" class="ion-no-margin">
  <ion-img [src]="itemData?.img">
  </ion-img>
  <ion-card-header class="ion-no-padding padl10 marb10">
    <ion-card-title class="line-2-clip">{{itemData?.title}}</ion-card-title>
  </ion-card-header>
  <ion-card-content class="ion-no-padding padl10 padb10">
    <div class="price mart10">
      <b>&#8377;{{itemData?.finalPrice}}</b>
      <ion-text color="success marl4">
        <span *ngIf="itemData?.discountVal > 0">({{itemData?.discountVal | number : '1.0-0'}}% off)</span>
      </ion-text>
    </div>
    <ion-text>
      <h6 class="ion-no-margin mart10 font12" *ngIf="!itemData?.rewards_campaign?.doNotShow && itemData?.rewards_campaign?.doNotShow">
        <ion-icon slot="start" name="wallet-outline"></ion-icon>
        {{itemData?.rewards_campaign?.displayText}}
      </h6>
    </ion-text>
  </ion-card-content>
</ion-card>